export default __webpack_public_path__ + "static/media/guide_dev_09.d2ee128e.md";